import { IPageTabNavLink } from "../interfaces-and-types";

export const customersNavLinks: IPageTabNavLink[] = [
    {
        name: 'Customers',
        route: '',
    },
]